import {
    Button,
    Checkbox,
    Divider,
    Icon,
    ListItemText,
    MenuItem, TextField,
} from "@mui/material";
import {ChangeEvent, useContext, useEffect, useState} from "react";
import { DialogContext } from "../../contexts/DialogueContext";
import DialogHeader from "./DialogHeader";

// updated
export default function MultiSelectMobile(props: {
    label: string;
    selectedIds: (string | number)[];
    values: { id?: string | number; title?: string }[];
    onValueChange: (values: (string | number)[]) => void;
    hasSearch?: boolean;
}) {
    const { closeDialog } = useContext(DialogContext);

    const allSelectedCode = -999;
    const [selectedIds, setSelectedIds] = useState([...props.selectedIds]);
    const isAllSelected = selectedIds.length === props.values.length;

    const [searchedItems, setSearchedItems] = useState<{ id?: number | string, title?: string }[]>(props.values)
    useEffect(() => {
        setSearchedItems(props.values);
    }, [props.values]);
    const handleSearch = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const searchTerm = event.target.value;
        if (searchTerm.length < 1) {
            setSearchedItems(props.values);
        } else {
            const result = props.values.filter(v => v.title.includes(searchTerm));
            setSearchedItems(result);
        }
    }

    const toggleMobileSelect = (value: number | string) => {
        if (value === allSelectedCode) {
            if (isAllSelected) {
                props.onValueChange([]);
                setSelectedIds([]);
            } else {
                const allIds = props.values.map((i) => i.id!);
                props.onValueChange(allIds);
                setSelectedIds(allIds);
            }

            return;
        }

        const updatedSelectedIds = [...selectedIds];
        const index = updatedSelectedIds.indexOf(value);

        if (index !== -1) {
            updatedSelectedIds.splice(index, 1);
        } else {
            updatedSelectedIds.push(value);
        }

        props.onValueChange(updatedSelectedIds);
        setSelectedIds(updatedSelectedIds);
    };

    return (
        <>
            <DialogHeader
                title={props.label}
                action={
                    <Button
                        size="small"
                        variant="contained"
                        color="secondary"
                        startIcon={<Icon>done</Icon>}
                        onClick={closeDialog}
                    >
                        تایید
                    </Button>
                }
            />

            {
                props.hasSearch && (
                    <TextField
                        onChange={e => handleSearch(e)}
                        onKeyDown={e => e.stopPropagation()}
                        sx={{width: '100%', "& fieldset": {border: 'none'}}}
                        placeholder='جستجو...'/>
                )
            }
            {/*The dividers are separated just to not get mui error from mui select component*/}
            {
                props.hasSearch && (
                    <Divider/>
                )
            }

            {searchedItems.length > 0 && !props.hasSearch && (
                <MenuItem
                    value={allSelectedCode}
                    sx={{marginTop: '8px'}}
                    disableRipple={true}
                    onClick={() => toggleMobileSelect(allSelectedCode)}
                >
                    <Checkbox checked={isAllSelected}/>
                    <ListItemText primary="انتخاب همه"/>
                </MenuItem>

            )}
            {
                searchedItems.length > 0 && !props.hasSearch && (
                    <Divider/>
                )
            }

            {searchedItems.map((i) => {
                return (
                    <MenuItem
                        selected={selectedIds.includes(i.id!)}
                        key={i.id?.toString()}
                        value={i.id}
                        onClick={() => toggleMobileSelect(i.id!)}
                    >
                        <Checkbox checked={selectedIds.includes(i.id!)} />
                        <ListItemText primary={i.title} />
                    </MenuItem>
                );
            })}
        </>
    );
}
